import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Divider } from '@mui/material';
import React from 'react';
import { jbColors } from 'theme/jbColors';

import { SxProps, Theme } from '@mui/material';

interface CommonDialogProps {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  content: React.ReactNode;
  removeCancel?: boolean;
  titleIcon?: React.ReactNode;
  closeIcon?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const CommonDialog = ({
  isOpen,
  onClose,
  title,
  content,
  removeCancel = false,
  titleIcon = null,
  closeIcon = null,
  sx,
}: CommonDialogProps) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      data-testid="common-dialog"
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{ sx: sx }}
    >
      <DialogTitle id="form-dialog-title">
        <Grid container>
          {titleIcon && (
            <Grid item xs={1} sx={{ justifyContent: 'flex-start', display: 'flex' }}>
              {titleIcon}
            </Grid>
          )}
          <Grid
            item
            xs={titleIcon ? 10 : 11}
            sx={{
              justifyContent: 'flex-start',
              display: 'flex',
              paddingLeft: 1,
              alignItems: 'center',
            }}
            data-testid={'common-dialog-title'}
          >
            {' '}
            {title}
          </Grid>
          <Grid
            item
            xs={1}
            sx={{
              justifyContent: 'flex-end',
              display: 'flex',
              cursor: 'pointer',
              alignItems: 'center',
            }}
          >
            {closeIcon}
          </Grid>
        </Grid>
        {title && <Divider sx={{ borderColor: jbColors.core.reflexBlue[100], mt: 1 }} />}
      </DialogTitle>
      <DialogContent className="scrollbarThinContainer">{content}</DialogContent>
      {!removeCancel && (
        <DialogActions>
          <Button
            sx={{
              color: jbColors.core.reflexBlue[100],
              backgroundColor: 'white',
              ':hover': {
                backgroundColor: jbColors.core.reflexBlue[100],
                color: 'white',
              },
            }}
            id="common-dialog-close"
            onClick={handleClose}
          >
            Close
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CommonDialog;
